import { BannerListInterface, DashboardInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const getInitialData: () => Promise<DashboardInterface> = (): Promise<DashboardInterface> => api.get('v1/dashboards');

export const getBanners: () => Promise<BannerListInterface> = (): Promise<BannerListInterface> => api.get('banners');
